import { ADHOC_EVENT_TYPE, MANAGED_EVENT_TYPE } from 'constants/event_types'

import { isNotetakerEligibleLocationKind } from './location_kinds'

export const isNotetakerEtToggleEligible = ({
  eventType,
  locationKind,
  integrationStatuses,
  organization,
  user,
  hasMsTeamsFlag = false,
}) => {
  if (!eventType || !locationKind || !integrationStatuses || !organization || !user) return false

  const isLocationEligible = isNotetakerEligibleLocationKind(locationKind, hasMsTeamsFlag)
    && Boolean(integrationStatuses[locationKind])
  if (!isLocationEligible) return false

  const isManagedEventType = Boolean(eventType.isMETParent || eventType.isMETChild)
    || eventType.type === MANAGED_EVENT_TYPE
  if (isManagedEventType) return false

  const isAdhocEventType = Boolean(eventType.isAdhocEventType)
    || eventType.type === ADHOC_EVENT_TYPE
    || eventType.type === 'adhoc'
  if (isAdhocEventType) return false

  const isPollEventType = Boolean(eventType.isPoll)
    || eventType.booking_method === 'poll'
    || eventType.kind_name === 'poll'
  if (isPollEventType) return false

  const isSingleSeatOrganization = organization.kind === 'single'
  if (!isSingleSeatOrganization) return false

  const isOwner = Boolean(organization.owner?.id)
    && Boolean(user.id)
    && organization.owner.id === user.id
  if (!isOwner) return false

  const hasEligibleCountry = user.country_code?.toUpperCase() === 'US'
  if (!hasEligibleCountry) return false

  const hasEligibleLocale = user.locale?.toLowerCase() === 'en'
  if (!hasEligibleLocale) return false

  return true
}
